module.exports = __webpack_public_path__ + "fonts/AnyConv.com__SourceSansPro-ExtraLightItalic.d3624a8d.woff";